/**
 * Where a location's cart is kept between page loads (with the same lifetime as
 * the flag cookie).
 *
 * One cookie per location, at one path. Written without a path, the browser
 * files a cookie under the folder of whichever page wrote it, so the menu
 * (`…/table/t1/menu`) and the checkout (`…/table/t1`) each kept their own
 * `cart`. Clearing it after an order emptied only one of them, and the next
 * load of a menu page brought the ordered items back — to be sent again as
 * duplicates.
 */
const CART_COOKIE_PREFIX = "cart_";

export const getCartCookieName = (locationId: string) =>
  `${CART_COOKIE_PREFIX}${locationId}`;

/** Every page that reads or writes the cart (the menu routes) is under it. */
export const getCartCookiePath = (locationId: string) =>
  `/location/${locationId}`;
